import React, { Fragment, useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Label,
  Form,
  Media,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Col,
} from "reactstrap";
import DataTable from "react-data-table-component";
import { Link, useNavigate } from "react-router-dom";
import SweetAlert from "sweetalert2";
import { Add } from "../../../Constant";
import { toast } from "react-toastify";
import { H3, Breadcrumbs, H4 } from "../../../AbstractElements";
import { getDataWithToken, postDataWithToken } from "../../../Utils/restUtils";
import SearchList from "../../../CommonElements/Search";
import Transparentspinner from "../../Common/loader/Transparentspinner";
import IndustryFilter from "../../Common/Filters/IndustryFilter";
import { getModule,deleteModule } from "../../../CommonURL";

const ModulesTable = () => {
  const [ModulesData, setModulesData] = useState([]);
  const [modulesList, setModulesList] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [tempSearch, setTempSearch] = useState("");
  const [isIndustry, setIsIndustry] = useState("");
  const [tempIndustry, setTempIndustry] = useState("");
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const navigate = useNavigate();

  const toggleStyle = {
    padding: "10px 20px",
    opacity: "0.8",
    fontSize: "14px",
  };

  useEffect(() => {
    getModulesData(1);
  }, []);

  const moduleColumns = [
    {
      name: <H4 attrH4={{ className: "mb-0" }}>Sl No</H4>,
      selector: (row) => row.Si,
      sortable: true,
      width: "70px",
      center: true,
    },
    {
      name: <i className="fa fa-gears" style={{ fontSize: "15px" }}></i>,
      selector: (row) => row.action,
      cell: (row) => <ActionCell row={row} />,
      width: "60px",
      center: true,
    },
    {
      name: <H4 attrH4={{ className: "mb-0" }}>Name</H4>,
      selector: (row) => row.Name,
      sortable: true,
      wrap: true,
      grow: 2,
      minWidth: "180px",
    },
    {
      name: <H4 attrH4={{ className: "mb-0" }}>Code</H4>,
      selector: (row) => row.Code,
      sortable: true,
      wrap: true,
      grow: 1,
      minWidth: "140px",
    },
    {
      name: <H4 attrH4={{ className: "mb-0" }}>Description</H4>,
      selector: (row) => row.Description,
      sortable: true,
      wrap: true,
      grow: 3,
      minWidth: "250px",
    },
  ];

  const getModulesData = async (
    page = currentPage,
    size = perPage,
    search = searchKeyword,
    industry_id = isIndustry?.value || "",
  ) => {
    setLoading(true);

    const response = await getDataWithToken(
      getModule +
        `?page=${page}&page_length=${size}&search=${search}&industry_type_id=${industry_id}`
    );

    let serialNo = (page - 1) * size + 1;
    const list =
      response?.data?.data ||
      response?.data ||
      (Array.isArray(response) ? response : []) ||
      [];
    const total = response?.data?.total ?? response?.total ?? list.length;

    setModulesList(list);
    setTotalRows(total);

    setModulesData(
      list.map((e, index) => ({
        Si: serialNo + index,
        id: e.id,
        Name: e.name || "-",
        Code: e.code || "-",
        Description: e.description || "-",
      }))
    );

    setLoading(false);
  };

  const handleFilter = () => {
    setCurrentPage(1);
    setSearchKeyword(tempSearch);
    setIsIndustry(tempIndustry);
    getModulesData(1, perPage, tempSearch, tempIndustry?.value || "");
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    getModulesData(page, perPage, searchKeyword, isIndustry?.value || "");
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    getModulesData(page, newPerPage, searchKeyword, isIndustry?.value || "");
  };

  const updateSearchKeyword = (keyword) => {
    setTempSearch(keyword);
  };

  const handleSwitchToggle = async (event, itemId) => {
    const checked = event.target.checked;
    let reqSwitch = null;
    if (checked === true) {
      reqSwitch = { module_id: itemId, status: "active" };
    } else {
      reqSwitch = { module_id: itemId, status: "inactive" };
    }
    toast.success("Status updated");
  };

  const deleteModulesList = async (moduleId) => {
  SweetAlert.fire({
    title: "Are you sure?",
    text: "Once deleted, you will not be able to recover this Module!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Ok",
    cancelButtonText: "Cancel",
    reverseButtons: true,
  }).then(async (result) => {
    if (result.isConfirmed) {
      setLoading(true);
      try {
        await postDataWithToken(deleteModule, { module_id: moduleId });
        SweetAlert.fire("Deleted!", "Module has been deleted.", "success");
        await getModulesData(currentPage);
      } catch (err) {
        toast.error("Failed to delete module.");
      } finally {
        setLoading(false);
      }
    }
  });
};

  const redirectToEditForm = (data) => {
    const editFormURL = `${process.env.PUBLIC_URL}/configuration/modules-edit?id=${data.id}`;
    navigate(editFormURL);
  };

  const ActionCell = ({ row }) => {
    const [dropdownOpen, setDropdownOpen] = React.useState(false);
    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    return (
      <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
        <DropdownToggle
          color="#00000"
          style={{ fontSize: "14px", zIndex: 1000 }}
        >
          <i className="fa fa-ellipsis-v"></i>
        </DropdownToggle>
        <DropdownMenu container="body">
          <DropdownItem
            style={toggleStyle}
            onClick={() => redirectToEditForm(row)}
          >
            Edit
          </DropdownItem>
            <DropdownItem
              style={{
                padding: "10px 20px",
                color: "red",
                opacity: "0.8",
                fontSize: "14px",
                margin: "0",
              }}
              onClick={() => deleteModulesList(row.id)}
            >
              Delete
            </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    );
  };

  return (
    <Fragment>
      {loading && <Transparentspinner />}
      <Breadcrumbs mainTitle="Module" parent="Configuration" title="Module" />
      <Card>
        <CardHeader
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <H3>Module List</H3>
          <div>
            <Link
              to={`${process.env.PUBLIC_URL}/configuration/modules-add`}
              className="btn btn-primary"
            >
              {Add}
            </Link>
          </div>
        </CardHeader>
        <Form
          className="px-4 pb-2"
          onSubmit={(e) => {
            e.preventDefault();
            handleFilter();
          }}
        >
          <Row className="g-3 align-items-center ">
            <Col sm="12" md="5" lg="3" className="pt-3">
              <SearchList
                updateSearchKeyword={updateSearchKeyword}
                onEnter={handleFilter}
              />
            </Col>

            {/* <Col sm="12" md="6" lg="3">
              <IndustryFilter
                IsIndustry={tempIndustry}
                setIsIndustry={setTempIndustry}
              />
            </Col> */}

            <Col sm="12" md="6" lg="3">
              <button type="submit" className="btn btn-primary">
                Filter
              </button>
            </Col>
          </Row>
        </Form>

        <CardBody>
          <div className="order-history table-responsive">
            <DataTable
              columns={moduleColumns}
              data={ModulesData}
              pagination
              paginationServer
              defaultSortAsc
              paginationTotalRows={totalRows}
              paginationDefaultPage={currentPage}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              paginationRowsPerPageOptions={[10, 25, 50, 100]}
            />
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default ModulesTable;
